var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Col } from "react-bootstrap";
import { omit, isString, isArray, xor, isEmpty } from "lodash";
import AsyncPaginate from "react-select-async-paginate";
import ValidationInput from "@irati/utils/validation/Input";
import { injectIntl, getResolvedMessage } from "@irati/utils/lang";
import newId from "@irati/utils/id";
import { FormGroup } from "../Form";
import ErrorText from "../ErrorText";
import HintText from "../HintText";
import perkboxStyles from "./styles/selectStyles";
var FormItemSelectInfiniteAsync = /** @class */ (function (_super) {
    __extends(FormItemSelectInfiniteAsync, _super);
    function FormItemSelectInfiniteAsync(props) {
        var _this = _super.call(this, props) || this;
        _this.handleBlur = function () {
            _this.validation.update();
        };
        _this.handleChange = function (value) {
            _this.setState({ value: value });
            _this.props.onChange(value);
        };
        _this.state = {
            errorMsg: null,
            blurred: false,
            value: props.value
        };
        _this.validation = new ValidationInput(_this);
        return _this;
    }
    FormItemSelectInfiniteAsync.getDerivedStateFromProps = function (props, state) {
        var propsValue = props.value;
        var stateValue = state.value;
        if ((isString(propsValue) && propsValue !== stateValue) ||
            isEmpty(stateValue) ||
            (isArray(propsValue) && (isArray(stateValue) && xor(propsValue, stateValue).length > 0))) {
            return {
                value: propsValue
            };
        }
        return null;
    };
    FormItemSelectInfiniteAsync.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.validation.update(prevProps, prevState);
    };
    FormItemSelectInfiniteAsync.prototype.componentWillUnmount = function () {
        this.validation.destroy();
    };
    FormItemSelectInfiniteAsync.prototype.render = function () {
        var _a = this.props, name = _a.name, label = _a.label, className = _a.className, hint = _a.hint, hideLabel = _a.hideLabel, labelKey = _a.labelKey, valueKey = _a.valueKey;
        var _b = this.state, errorMsg = _b.errorMsg, value = _b.value;
        var idNamespace = newId("select-infinite-async", this.props);
        var formItemId = newId("form-input", idNamespace);
        var selectProps = omit(this.props, ["className", "label", "validation", "formatMessage", "translate"]);
        return (React.createElement(FormGroup, { id: idNamespace, className: className, controlId: name, validationState: errorMsg ? "error" : undefined },
            React.createElement(Col, { hidden: hideLabel, xs: 12 },
                React.createElement("label", { id: newId("label", idNamespace), htmlFor: formItemId }, label)),
            React.createElement(Col, { xs: 12 },
                React.createElement(AsyncPaginate, __assign({}, selectProps, { id: formItemId, name: name, value: value, onChange: this.handleChange, onBlur: this.handleBlur, getOptionLabel: labelKey ? function (option) { return option[labelKey]; } : undefined, getOptionValue: valueKey ? function (option) { return option[valueKey]; } : undefined, shouldLoadMore: function (scrollHeight, clientHeight, scrollTop) {
                        return scrollTop > 0 && clientHeight + scrollTop + 50 > scrollHeight;
                    }, styles: perkboxStyles })),
                errorMsg && (React.createElement("div", null,
                    React.createElement(ErrorText, { small: true }, getResolvedMessage(this, "errorMsg", this.state)))),
                hint && (React.createElement("div", null,
                    React.createElement(HintText, { small: true }, hint))))));
    };
    FormItemSelectInfiniteAsync.contextTypes = {
        currentScreen: PropTypes.string
    };
    FormItemSelectInfiniteAsync.defaultProps = {
        className: "",
        id: "",
        hideLabel: false,
        valueKey: "value",
        labelKey: "label"
    };
    return FormItemSelectInfiniteAsync;
}(Component));
export { FormItemSelectInfiniteAsync };
export default injectIntl(FormItemSelectInfiniteAsync);
